import { render, staticRenderFns } from "./FilesAndAttachmentsForShow.vue?vue&type=template&id=21c204d5"
import script from "./FilesAndAttachmentsForShow.vue?vue&type=script&lang=js"
export * from "./FilesAndAttachmentsForShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports